module.exports = __webpack_public_path__ + "static/media/030-cyprus.ffbda7ca.svg";